module.exports = __webpack_public_path__ + "static/media/08.92fa0748.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/08.jpg
// module id = 467
// module chunks = 0